export default class TypeConfiguration {
	constructor({added_on, name, json_base, id, json_properties, status_id}) {
		this.added_on = added_on ? added_on : "";
		this.name = name ? name : "";
		this.id = id ? id : 0;
		this.status_id = status_id ? status_id : 0;

		this.json_base = json_base
			? this.validateJsonBase(json_base)
			: {
					$schema: "http://json-schema.org/draft-06/schema#",
					additionalProperties: false,
					properties: {},
					required: [],
					type: "object",
			  };
		this.json_properties = json_properties ? json_properties : [];
	}

	validateJsonBase(json_base) {
		if (Object.hasOwnProperty.call(json_base, "$schema")) {
			return json_base;
		} else {
			return {
				$schema: json_base.$schema ? json_base.$schema : "http://json-schema.org/draft-06/schema#",
				additionalProperties: json_base.additionalProperties ? json_base.additionalProperties : false,
				properties: json_base.properties ? json_base.properties : {},
				required: json_base.required ? json_base.required : [],
				type: json_base.type ? json_base.type : "object",
			};
		}
	}
}
